import React from "react";
import ConnectionFrame from "../components/ConnectionFrame";

interface props {
  bg: string;
  startSession: () => void;
}

const Home: React.FC<props> = ({ bg, startSession }) => {
  return (
    <div className="w-full h-full bg-black">
      <div className="opacity-70 blur-sm absolute top-0 left-0 bg-[url(./assets/bg.png)] w-full h-full bg-center"></div>
      <ConnectionFrame startSession={startSession}></ConnectionFrame>
    </div>
  );
};

export default Home;
